import { StringUtils } from '@grandvisionhq/utils';

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const DAY_NAMES = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
const getDayName = (date)=>{
    let day;
    const dayOfWeek = new Date(date).getDay() - 1;
    if (dayOfWeek < 0) {
        day = DAY_NAMES[DAY_NAMES.length - 1];
    } else if (dayOfWeek >= 0 && dayOfWeek < DAY_NAMES.length) {
        day = DAY_NAMES[dayOfWeek];
    }
    if (!day) {
        throw new Error('Invalid day index') // Handle unexpected cases explicitly
        ;
    }
    return `https://schema.org/${StringUtils.upFirst(day)}`;
};
const getSpecialOpeningHours = (specialOpeningHours)=>{
    let i1 = 0;
    return [
        ...specialOpeningHours
    ].sort((a, b)=>Date.parse(a.dateOpenClosed) - Date.parse(b.dateOpenClosed)
    ).reduce((acc, item)=>{
        var ref4, ref1;
        const current = acc[i1];
        const lastDateInCurrent = current === null || current === void 0 ? void 0 : (ref4 = current[current.length - 1]) === null || ref4 === void 0 ? void 0 : ref4.dateOpenClosed;
        const a = lastDateInCurrent ? Date.parse(lastDateInCurrent) : 0;
        const b = Date.parse(item.dateOpenClosed);
        // if the item is not on a consecutive day to the previous item, put it in a new array.
        if (current && b - a > DAY_IN_MS) {
            i1++;
        }
        // if the item's openClosed is not the same as the previous item or any of
        // the openClosedTime entries differs from the previous item, put it in a new array.
        if (current && current.length > 0) {
            var ref2;
            if (((ref2 = current[0]) === null || ref2 === void 0 ? void 0 : ref2.openClosed) !== item.openClosed) {
                i1++;
            } else if (current[0].openClosedTime && item.openClosedTime) {
                const sameOpenClosedTime = current[0].openClosedTime.every((time, i)=>{
                    var ref, ref3;
                    if (!item.openClosedTime || !item.openClosedTime[i]) {
                        return false;
                    }
                    return time.open === ((ref = item.openClosedTime[i]) === null || ref === void 0 ? void 0 : ref.open) && time.close === ((ref3 = item.openClosedTime[i]) === null || ref3 === void 0 ? void 0 : ref3.close);
                });
                if (!sameOpenClosedTime) {
                    i1++;
                }
            }
        }
        if (!acc[i1]) {
            acc[i1] = [];
        }
        (ref1 = acc[i1]) === null || ref1 === void 0 ? void 0 : ref1.push(item);
        return acc;
    }, []).reduce((acc, period)=>{
        const first = period[0];
        const last = period[period.length - 1];
        const dayOfWeek = period.length > 1 ? period.map((day)=>getDayName(day.dateOpenClosed)
        ) : getDayName((first === null || first === void 0 ? void 0 : first.dateOpenClosed) || '');
        let opens = '00:00';
        let closes = '00:00';
        if ((first === null || first === void 0 ? void 0 : first.openClosed) === 'OPEN' && first.openClosedTime) {
            var ref, ref5;
            opens = ((ref = first.openClosedTime[0]) === null || ref === void 0 ? void 0 : ref.open) || opens;
            closes = ((ref5 = first.openClosedTime[0]) === null || ref5 === void 0 ? void 0 : ref5.close) || closes;
        }
        acc.push({
            '@type': 'OpeningHoursSpecification',
            dayOfWeek,
            opens,
            closes,
            validFrom: first === null || first === void 0 ? void 0 : first.dateOpenClosed,
            validThrough: last === null || last === void 0 ? void 0 : last.dateOpenClosed
        });
        return acc;
    }, []);
};

export { getSpecialOpeningHours };
//# sourceMappingURL=get-special-opening-hours.js.map
